export default {
  sm: `
  Cloud certified with 
  domestic and 
  international standards    
  `,
  md: `
  Cloud certified with domestic
  and international standards    
  `,
  xxl: `
  Cloud certified with 
  domestic and 
  international standards    
  `,
};
